import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["actions", "children"];

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React from 'react';
import { createButton } from '@flowio/react-button';

var rootStyles = function rootStyles(theme) {
  return /*#__PURE__*/css({
    display: 'inline-flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    '& .action:not(:first-of-type)': {
      marginLeft: theme.direction === 'ltr' ? '0.75rem' : undefined,
      marginRight: theme.direction === 'rtl' ? '0.75rem' : undefined,
      marginInlineStart: '0.75rem'
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:rootStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0NhcmRBY3Rpb25zLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFvQnVEIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0NhcmRBY3Rpb25zLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuXG5pbXBvcnQgeyBjc3MsIGpzeCwgU2VyaWFsaXplZFN0eWxlcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB0eXBlIHsgVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3JlYXRlQnV0dG9uIH0gZnJvbSAnQGZsb3dpby9yZWFjdC1idXR0b24nO1xuaW1wb3J0IHR5cGUgeyBCdXR0b25TaG9ydGhhbmQgfSBmcm9tICdAZmxvd2lvL3JlYWN0LWJ1dHRvbic7XG5cbnR5cGUgT3duUHJvcHMgPSB7XG4gIGFjdGlvbnM/OiBCdXR0b25TaG9ydGhhbmRbXTtcbiAgY2hpbGRyZW4/OiBSZWFjdC5SZWFjdE5vZGU7XG59O1xuXG50eXBlIFVuaGFuZGxlZFByb3BzID0gT21pdDxcbiAgUmVhY3QuSFRNTEF0dHJpYnV0ZXM8SFRNTERpdkVsZW1lbnQ+LFxuICBrZXlvZiBPd25Qcm9wc1xuPjtcblxudHlwZSBQcm9wcyA9IE93blByb3BzICYgVW5oYW5kbGVkUHJvcHM7XG5cbmNvbnN0IHJvb3RTdHlsZXMgPSAodGhlbWU6IFRoZW1lKTogU2VyaWFsaXplZFN0eWxlcyA9PiBjc3Moe1xuICBkaXNwbGF5OiAnaW5saW5lLWZsZXgnLFxuICBmbGV4RmxvdzogJ3JvdyBub3dyYXAnLFxuICBhbGlnbkl0ZW1zOiAnY2VudGVyJyxcbiAgJyYgLmFjdGlvbjpub3QoOmZpcnN0LW9mLXR5cGUpJzoge1xuICAgIG1hcmdpbkxlZnQ6IHRoZW1lLmRpcmVjdGlvbiA9PT0gJ2x0cicgPyAnMC43NXJlbScgOiB1bmRlZmluZWQsXG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLmRpcmVjdGlvbiA9PT0gJ3J0bCcgPyAnMC43NXJlbScgOiB1bmRlZmluZWQsXG4gICAgbWFyZ2luSW5saW5lU3RhcnQ6ICcwLjc1cmVtJyxcbiAgfSxcbn0pO1xuXG5jb25zdCBDYXJkQWN0aW9uczogUmVhY3QuRkM8UHJvcHM+ID0gKHtcbiAgYWN0aW9ucyA9IFtdLFxuICBjaGlsZHJlbixcbiAgLi4udW5oYW5kbGVkUHJvcHNcbn0pID0+IChcbiAgPGRpdiB7Li4udW5oYW5kbGVkUHJvcHN9IGNzcz17cm9vdFN0eWxlc30+XG4gICAge2NoaWxkcmVuICE9IG51bGwgPyBjaGlsZHJlbiA6IGFjdGlvbnMubWFwKChhY3Rpb24sIGluZGV4KSA9PiBjcmVhdGVCdXR0b24oYWN0aW9uLCB7XG4gICAgICBkZWZhdWx0UHJvcHM6IHtcbiAgICAgICAga2V5OiBpbmRleCxcbiAgICAgIH0sXG4gICAgICBvdmVycmlkZVByb3BzOiB7XG4gICAgICAgIGNsYXNzTmFtZTogJ2FjdGlvbicsXG4gICAgICB9LFxuICAgIH0pKX1cbiAgPC9kaXY+XG4pO1xuXG5DYXJkQWN0aW9ucy5kaXNwbGF5TmFtZSA9ICdDYXJkQWN0aW9ucyc7XG5cbmV4cG9ydCBkZWZhdWx0IENhcmRBY3Rpb25zO1xuIl19 */");
};

var CardActions = function CardActions(_ref) {
  var _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? [] : _ref$actions,
      children = _ref.children,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return jsx("div", _extends({}, unhandledProps, {
    css: rootStyles
  }), children != null ? children : actions.map(function (action, index) {
    return createButton(action, {
      defaultProps: {
        key: index
      },
      overrideProps: {
        className: 'action'
      }
    });
  }));
};

CardActions.displayName = 'CardActions';
export default CardActions;